import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import FlatButton from 'material-ui/FlatButton';
import { translate, showNotification as showNotificationAction } from 'admin-on-rest';
import { push as pushAction } from 'react-router-redux';
import { refreshView as refreshViewAction } from 'admin-on-rest';
import restClient from '../restClient';

class DeleteMonthReportsButton extends Component {
    handleClick = () => {
        restClient('DELETE_ALL', 'admin/deleteallmonthreports', {action: 'delete_all'} )
			   .then((response) => {
				  	showNotificationAction('aor.notification.updated','confirm');
					   
					pushAction('/admin/clicks_report_monthgrouped');
					this.props.refreshView();
				})
				.catch((e) => {
					console.error(e);
					showNotificationAction('cloudhitns.error_try_again','warning')
				});
    }

    render() {
        return <FlatButton label="Delete all reports & regenerate historical reports" onClick={this.handleClick} />;
    }
}

DeleteMonthReportsButton.propTypes = {
    push: PropTypes.func,
    record: PropTypes.object,
    showNotification: PropTypes.func,
};

export default connect(null, {
    showNotification: showNotificationAction,
    push: pushAction,
	refreshView: refreshViewAction
})(DeleteMonthReportsButton);


// WEBPACK FOOTER //
// ./src/siteclicks/DeleteMonthReportsButton.js